import { HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { STORAGE_KEYS } from '../app.constants';
import { inject } from '@angular/core';
import { StorageService } from '../providers/storage.service';

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {
  const authStorage = inject(StorageService);
  const validationToken = authStorage.getItem(STORAGE_KEYS.VALIDATION_TOKEN);
  const authToken = authStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const activityId = authStorage.getItem(STORAGE_KEYS.ACTIVITY_ID);
  const apiKey = authStorage.getItem(STORAGE_KEYS.API_KEY);
  const flowId = authStorage.getItem(STORAGE_KEYS.FLOW_ID);
  let newParams = new HttpParams({ fromString: req.params.toString() });

  if (!req.params.has('validationToken') && validationToken && flowId) {
    newParams = newParams.append('validationToken', validationToken);
    newParams = newParams.append('masterFlowId', flowId);

    if (activityId) {
      newParams = newParams.append('activityId', activityId);
    }
  }

  if (!req.params.has('authToken') && authToken) {
    newParams = newParams.append('authToken', authToken);
  }

  if (!req.params.has('apiKey') && apiKey) {
    newParams = newParams.append('apiKey', apiKey);
  }

  const modifiedReq = req.clone({
    params: newParams,
  });

  return next(modifiedReq);
};
